import React, { useContext, useMemo } from "react";
import { CheckOutlined, HolderOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
	arrayMove,
	SortableContext,
	useSortable,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, Card, Flex, Table } from "antd";
import PropTypes from "prop-types";

const RowContext = React.createContext({});
const DragHandle = () => {
	const { setActivatorNodeRef, listeners } = useContext(RowContext);
	return (
		<Button
			type='text'
			size='small'
			icon={<HolderOutlined />}
			style={{
				cursor: "move",
			}}
			ref={setActivatorNodeRef}
			{...listeners}
		/>
	);
};

const Row = (props) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		setActivatorNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
		id: props["data-row-key"],
	});
	const style = {
		transform: CSS.Translate.toString(transform),
		transition,
		...(isDragging
			? {
					position: "relative",
					zIndex: 9999,
			  }
			: {}),
	};
	const contextValue = useMemo(
		() => ({
			setActivatorNodeRef,
			listeners,
		}),
		[setActivatorNodeRef, listeners]
	);
	return (
		<RowContext.Provider value={contextValue}>
			<tr {...props} ref={setNodeRef} style={style} {...attributes} />
		</RowContext.Provider>
	);
};

const ReorganisableList = ({
	initialData,
	initialColumns,
	onSaveOrder,
	onCancelOrder,
	updatingOrder,
}) => {
	const [dataSource, setDataSource] = React.useState([]);
	const [columns, setColumns] = React.useState([]);
	const onDragEnd = ({ active, over }) => {
		if (active.id !== over?.id) {
			setDataSource((prevState) => {
				const activeIndex = prevState.findIndex(
					(record) => record.key === active?.id
				);
				const overIndex = prevState.findIndex(
					(record) => record.key === over?.id
				);
				return arrayMove(prevState, activeIndex, overIndex);
			});
		}
	};

	React.useEffect(() => {
		setDataSource(
			initialData.map((item, index) => ({ ...item, key: ++index }))
		);

		const initialC = initialColumns.slice(0, -1);

		setColumns([
			{
				key: "sort",
				align: "center",
				width: 40,
				render: () => <DragHandle />,
			},
			...initialC,
		]);
	}, [initialData, initialColumns]);

	React.useEffect(() => {
		console.log(dataSource.map((i) => i.code));
	}, [dataSource]);
		
	return (
		<>
			<Card>
				<Flex justify='end' gap={8}>
					<Button
						onClick={() => onSaveOrder(dataSource)}
						type='primary'
						icon={<CheckOutlined />}
					>
						Valider
					</Button>
					<Button onClick={onCancelOrder}>Annuler</Button>
				</Flex>
			</Card>
			{dataSource && (
				<DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
					<SortableContext
						items={dataSource.map((i) => i.key)}
						strategy={verticalListSortingStrategy}
					>
						<Table pagination={false}
							rowKey='key'
							components={{
								body: {
									row: Row,
								},
							}}
							columns={columns}
							dataSource={dataSource}
							loading={updatingOrder}
						/>
					</SortableContext>
				</DndContext>
			)}
		</>
	);
};
export default ReorganisableList;

ReorganisableList.propTypes = {
	initialData: PropTypes.array,
	initialColumns: PropTypes.array,
	onSaveOrder: PropTypes.func,
	onCancelOrder: PropTypes.func,
	updatingOrder: PropTypes.bool,
};
